var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import { appendStylesToTheStyleRoot } from '../../utilities/dom';
import { hideMenuProvider } from '../../utilities/picker.tools';
import stylesGlobal from '../shared/sds-datepicker-item/_sds-date-picker-base.lit.scss';
import { translate } from '../../utilities/translate';
import { displayQuarterDate, quarterDateToKey, quarterKeyToDate, } from './quarter-picker-calculations';
import '../shared/calendar/sds-calendar.lit';
import styles from '../sds-date-picker.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-quarter-picker` is a web component that enables users to select a specific quarter
 * of the year, offering a user-friendly interface for navigating through quarters.
 * It is particularly useful for applications that require date-based filtering or reporting,
 * such as financial applications or scheduling tools.
 *
 * ### Features:
 * - **Quarter Selection**: Users can easily choose a quarter.
 * - **Locale Support**: The component formats the quarter names according to the user's locale.
 * - **Accessibility**: Designed to be keyboard-friendly and compliant with accessibility standards.
 * - **Clear Functionality**: Optionally allows users to clear their selection for a fresh start.
 * - **Events**: Emits events to notify parent components of changes in quarter selection.
 */
let SdsQuarterPicker = (() => {
    var _SdsQuarterPicker_placeholder_accessor_storage, _SdsQuarterPicker_hint_accessor_storage, _SdsQuarterPicker_disabled_accessor_storage, _SdsQuarterPicker_invalid_accessor_storage, _SdsQuarterPicker_errorMessage_accessor_storage, _SdsQuarterPicker_selectedQuarter_accessor_storage, _SdsQuarterPicker_currentQuarter_accessor_storage, _SdsQuarterPicker__locale_accessor_storage, _SdsQuarterPicker__contextMenu_accessor_storage, _SdsQuarterPicker__inputDate_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-quarter-picker')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let _selectedQuarter_decorators;
    let _selectedQuarter_initializers = [];
    let _selectedQuarter_extraInitializers = [];
    let _currentQuarter_decorators;
    let _currentQuarter_initializers = [];
    let _currentQuarter_extraInitializers = [];
    let __locale_decorators;
    let __locale_initializers = [];
    let __locale_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __inputDate_decorators;
    let __inputDate_initializers = [];
    let __inputDate_extraInitializers = [];
    var SdsQuarterPicker = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsQuarterPicker_placeholder_accessor_storage.set(this, __runInitializers(this, _placeholder_initializers, 'sds.quarter_picker.placeholder'));
            _SdsQuarterPicker_hint_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsQuarterPicker_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsQuarterPicker_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsQuarterPicker_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsQuarterPicker_selectedQuarter_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, _selectedQuarter_initializers, void 0)));
            _SdsQuarterPicker_currentQuarter_accessor_storage.set(this, (__runInitializers(this, _selectedQuarter_extraInitializers), __runInitializers(this, _currentQuarter_initializers, void 0)));
            _SdsQuarterPicker__locale_accessor_storage.set(this, (__runInitializers(this, _currentQuarter_extraInitializers), __runInitializers(this, __locale_initializers, 'en')));
            _SdsQuarterPicker__contextMenu_accessor_storage.set(this, (__runInitializers(this, __locale_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsQuarterPicker__inputDate_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __inputDate_initializers, void 0)));
            this._sdsInnerQuarterPicker = __runInitializers(this, __inputDate_extraInitializers);
            this.stylesGlobal = stylesGlobal;
            this.hideMenu = hideMenuProvider(this);
            this.handleCleared = () => {
                var _a;
                this._inputDate.focused = Boolean((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened);
                this.updateSelectedQuarter();
                this.updatePageIndex();
            };
            this.handleQuarterPicked = (event) => {
                this.updateSelectedQuarter([event.detail.year, event.detail.quarter]);
            };
            this.handleYearChanged = (event) => {
                var _a;
                (_a = this._sdsInnerQuarterPicker) === null || _a === void 0 ? void 0 : _a.setYearStateMapper(keyYear => event.detail.year === keyYear ? 'selected' : 'none');
            };
            this.showContextMenu = () => {
                var _a, _b;
                if (!((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened)) {
                    this.resetPage();
                    this._inputDate.focused = true;
                    const trigger = this._inputDate.getInput();
                    (_b = this._contextMenu) === null || _b === void 0 ? void 0 : _b.show(trigger);
                    this.setMappers();
                }
            };
        }
        /**
         * Sets the placeholder text for the quarter picker input, providing a hint to users when no quarter is selected.
         * This attribute helps guide users to understand the expected input or purpose of the quarter selection.
         *
         * This placeholder text enhances accessibility and user experience by indicating
         * what the user is expected to select.
         *
         * @attr {string} placeholder - Placeholder text for the quarter picker input.
         */
        get placeholder() { return __classPrivateFieldGet(this, _SdsQuarterPicker_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsQuarterPicker_placeholder_accessor_storage, value, "f"); }
        /**
         * Hint for this quarter picker.
         * @attr
         */
        get hint() { return __classPrivateFieldGet(this, _SdsQuarterPicker_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsQuarterPicker_hint_accessor_storage, value, "f"); }
        /**
         * True if this quarter picker is disabled.
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsQuarterPicker_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsQuarterPicker_disabled_accessor_storage, value, "f"); }
        /**
         * True if this quarter picker is invalid.
         * @attr
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsQuarterPicker_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsQuarterPicker_invalid_accessor_storage, value, "f"); }
        /**
         * The error message of this quarter picker, in case there is a validation error.
         * @attr
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsQuarterPicker_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsQuarterPicker_errorMessage_accessor_storage, value, "f"); }
        /**
         * Represents the currently selected quarter within the quarter picker.
         *
         * The value can either be a `LocalQuarter` object or `undefined` if no quarter is selected.
         *
         * When this attribute is set, it automatically updates the UI to reflect the selected quarter.
         *
         * @attr {LocalQuarter} selected-quarter - The currently selected quarter in the quarter picker.
         */
        get selectedQuarter() { return __classPrivateFieldGet(this, _SdsQuarterPicker_selectedQuarter_accessor_storage, "f"); }
        set selectedQuarter(value) { __classPrivateFieldSet(this, _SdsQuarterPicker_selectedQuarter_accessor_storage, value, "f"); }
        /**
         * Represents the current quarter displayed in the quarter picker.
         * It is formatted as `{year}/{quarter}`, allowing the component to maintain context
         * for the quarter selection.
         *
         * This attribute is essential for initializing the component with the current quarter,
         * helping users quickly navigate to the relevant quarter options.
         *
         * The value can be either a string in the format of `{year}/{quarter}` or `undefined`
         * if no current quarter is specified.
         *
         * @attr {string} current-quarter - The current quarter in `{year}/{quarter}` format.
         */
        get currentQuarter() { return __classPrivateFieldGet(this, _SdsQuarterPicker_currentQuarter_accessor_storage, "f"); }
        set currentQuarter(value) { __classPrivateFieldSet(this, _SdsQuarterPicker_currentQuarter_accessor_storage, value, "f"); }
        get _locale() { return __classPrivateFieldGet(this, _SdsQuarterPicker__locale_accessor_storage, "f"); }
        set _locale(value) { __classPrivateFieldSet(this, _SdsQuarterPicker__locale_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsQuarterPicker__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsQuarterPicker__contextMenu_accessor_storage, value, "f"); }
        get _inputDate() { return __classPrivateFieldGet(this, _SdsQuarterPicker__inputDate_accessor_storage, "f"); }
        set _inputDate(value) { __classPrivateFieldSet(this, _SdsQuarterPicker__inputDate_accessor_storage, value, "f"); }
        render() {
            return html `
            <sds-input-date
                id="input-date"
                placeholder="${translate(this.placeholder)}"
                readonly
                ?disabled="${this.disabled}"
                hint="${this.hint}"
                error-message="${this.errorMessage}"
                ?invalid="${this.invalid}"
                @click="${this.showContextMenu}"
                @sds.input-date.cleared="${this.handleCleared}"
            ></sds-input-date>
            <sds-context-menu>
                <sds-inner-quarter-picker
                    id="sds-inner-quarter-picker"
                    locale="${this._locale}"
                    currentQuarter="${this.currentQuarter}"
                    @sds.inner-quarter-picker.changed="${this.handleQuarterPicked}"
                    @sds.inner-quarter-picker.year-changed="${this.handleYearChanged}"
                >
                </sds-inner-quarter-picker>
            </sds-context-menu>
        `;
        }
        willUpdate(_changedProperties) {
            if (_changedProperties.has('selectedQuarter')) {
                this.setMappers();
                this.hideContextMenu();
            }
        }
        updated(_changedProperties) {
            if (_changedProperties.has('selectedQuarter')) {
                if (this.selectedQuarter) {
                    this.updateInput(this.selectedQuarter);
                }
                else {
                    this.updateInput();
                }
            }
        }
        connectedCallback() {
            super.connectedCallback();
            document.addEventListener('mouseup', this.hideMenu);
        }
        disconnectedCallback() {
            document.removeEventListener('mouseup', this.hideMenu);
            this.hideContextMenu();
            super.disconnectedCallback();
        }
        async firstUpdated() {
            appendStylesToTheStyleRoot(this, 'sds-inner-quarter-picker', this.stylesGlobal.cssText);
            this.initCmContentContainer();
            await this.updateComplete;
            this.updatePageIndex();
        }
        initCmContentContainer() {
            var _a;
            const sdsInnerQuarterPicker = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-inner-quarter-picker');
            if (sdsInnerQuarterPicker) {
                this._sdsInnerQuarterPicker = sdsInnerQuarterPicker;
            }
        }
        updatePageIndex() {
            var _a, _b;
            if (this.selectedQuarter) {
                (_a = this._sdsInnerQuarterPicker) === null || _a === void 0 ? void 0 : _a.updatePageIndex(this.selectedQuarter[0]);
            }
            else if (this.currentQuarter) {
                (_b = this._sdsInnerQuarterPicker) === null || _b === void 0 ? void 0 : _b.updatePageIndex(quarterKeyToDate(this.currentQuarter)[0]);
            }
        }
        resetPage() {
            var _a;
            (_a = this._sdsInnerQuarterPicker) === null || _a === void 0 ? void 0 : _a.navigateTo('SelectQuarter');
            this.updatePageIndex();
        }
        hideContextMenu() {
            var _a;
            if ((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                this._contextMenu.hide();
            }
        }
        dispatchChange() {
            this.dispatchEvent(new CustomEvent(SdsQuarterPicker.QUARTER_PICKER_CHANGE_EVENT, {
                detail: {
                    selectedQuarter: this.selectedQuarter
                        ? quarterDateToKey(...this.selectedQuarter)
                        : undefined,
                },
            }));
        }
        updateSelectedQuarter(quarter) {
            this.selectedQuarter = quarter;
            this.dispatchChange();
            this.setMappers();
        }
        setMappers() {
            var _a, _b;
            const [year, quarter] = this.selectedQuarter ? this.selectedQuarter : [];
            (_a = this._sdsInnerQuarterPicker) === null || _a === void 0 ? void 0 : _a.setQuarterStateMapper(([keyYear, keyQuarter]) => year === keyYear && quarter === keyQuarter ? 'selected' : 'none');
            (_b = this._sdsInnerQuarterPicker) === null || _b === void 0 ? void 0 : _b.setYearStateMapper(keyYear => year === keyYear ? 'selected' : 'none');
        }
        updateInput(quarter) {
            this._inputDate.value = quarter ? displayQuarterDate(quarter) : '';
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
    };
    _SdsQuarterPicker_placeholder_accessor_storage = new WeakMap();
    _SdsQuarterPicker_hint_accessor_storage = new WeakMap();
    _SdsQuarterPicker_disabled_accessor_storage = new WeakMap();
    _SdsQuarterPicker_invalid_accessor_storage = new WeakMap();
    _SdsQuarterPicker_errorMessage_accessor_storage = new WeakMap();
    _SdsQuarterPicker_selectedQuarter_accessor_storage = new WeakMap();
    _SdsQuarterPicker_currentQuarter_accessor_storage = new WeakMap();
    _SdsQuarterPicker__locale_accessor_storage = new WeakMap();
    _SdsQuarterPicker__contextMenu_accessor_storage = new WeakMap();
    _SdsQuarterPicker__inputDate_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsQuarterPicker");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _placeholder_decorators = [property({ type: String })];
        _hint_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        _selectedQuarter_decorators = [property({
                attribute: 'selected-quarter',
                converter: quarterKeyToDate,
            })];
        _currentQuarter_decorators = [property({ attribute: 'current-quarter' })];
        __locale_decorators = [state()];
        __contextMenu_decorators = [query('sds-context-menu')];
        __inputDate_decorators = [query('#input-date')];
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, _selectedQuarter_decorators, { kind: "accessor", name: "selectedQuarter", static: false, private: false, access: { has: obj => "selectedQuarter" in obj, get: obj => obj.selectedQuarter, set: (obj, value) => { obj.selectedQuarter = value; } }, metadata: _metadata }, _selectedQuarter_initializers, _selectedQuarter_extraInitializers);
        __esDecorate(_classThis, null, _currentQuarter_decorators, { kind: "accessor", name: "currentQuarter", static: false, private: false, access: { has: obj => "currentQuarter" in obj, get: obj => obj.currentQuarter, set: (obj, value) => { obj.currentQuarter = value; } }, metadata: _metadata }, _currentQuarter_initializers, _currentQuarter_extraInitializers);
        __esDecorate(_classThis, null, __locale_decorators, { kind: "accessor", name: "_locale", static: false, private: false, access: { has: obj => "_locale" in obj, get: obj => obj._locale, set: (obj, value) => { obj._locale = value; } }, metadata: _metadata }, __locale_initializers, __locale_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __inputDate_decorators, { kind: "accessor", name: "_inputDate", static: false, private: false, access: { has: obj => "_inputDate" in obj, get: obj => obj._inputDate, set: (obj, value) => { obj._inputDate = value; } }, metadata: _metadata }, __inputDate_initializers, __inputDate_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsQuarterPicker = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.QUARTER_PICKER_CHANGE_EVENT = 'sds.quarter-picker.changed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsQuarterPicker = _classThis;
})();
export { SdsQuarterPicker };
